import CreatorPutStoryPage from "./CreatorPutStoryPage";

export default CreatorPutStoryPage;
